import React, { useEffect, useState } from 'react';
import Layout from '../../Layout/Layout';
import { ImFilesEmpty } from "react-icons/im";
import { BsShop } from "react-icons/bs";
import { getbidderscount, gettokencount } from '../../actions/users';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {

  const navigate = useNavigate();

  const [dashcount] = useState([
    {
      dashicon: <ImFilesEmpty />,
      dashhead: "Total NFTs",
      dashcount: 28,
      dashdesc: "NFTs",
      countkey: 'token',
      url: "/TokenList",
    },
    {
      dashicon: <BsShop />,
      dashhead: "Total Users",
      dashcount: 20,
      dashdesc: "Users",
      countkey: 'user',
      url: "/UserList",
    },
  ])
  const [count, setCount] = useState({
    bidder: 0,
    user: 0,
    token: 0,
    burn: 0,
  });

  useEffect(() => {
    gettokencounts();
  }, [])

  const gettokencounts = async () => {
    var test = await gettokencount();
    let setdata = {...count};
    if (test && test.userValue) {
      setdata.token = test.userValue.countData;
      setdata.burn = test.userValue.burnData;
      setdata.user = test.userValue.userCountData;
    }
    let bidcount = await getbidderscount();
    if (bidcount && bidcount.userValue) {
      setdata.bidder = bidcount.userValue;
    }
    setCount(setdata);
  }

  return (
    <Layout>
      <div className="dashboard">
        <h1 className="pagehead">Dashboard</h1>
        <div className="cardbox">
          <div className="dashboard_boxtop">
            {
              dashcount.map((dac) => (
                <div className="dashboard_box cursor_pointer" key={dac.dashhead} onClick={()=>navigate(dac.url)}>
                  <div>
                    <div className={`dashboard_iconbox ${dac.dashdesc === "NFTs" ? "warning" : "success"}`}>{dac.dashicon}</div>
                  </div>
                  <div>
                    <p className="dashboard_boxhead">{dac.dashhead}</p>
                    <p className="dashboard_boxdesc">
                      <span className="t-primary dashcount">{count?.[dac.countkey]?count?.[dac.countkey]:0}</span>
                      <span className="t-grey">{dac.dashdesc}</span>
                    </p>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Dashboard;